export default "__VITE_ASSET__vGkipWfr__"